import React from "react";
import { PROJECTS, IMAGES } from "@/data/site";
import LeadForm from "@/components/LeadForm";

const ALL = [
  ...PROJECTS,
  { id: 6, title: "8kW On-Grid Solar — Trichy Residence", category: "Solar", image: IMAGES.solar },
  { id: 7, title: "16-Camera IP Surveillance — School Campus", category: "CCTV", image: IMAGES.cctv },
  { id: 8, title: "Lithium UPS Backup — Hospital ICU", category: "Power", image: IMAGES.power },
  { id: 9, title: "EV Charging Hub — 4 Bays", category: "EV", image: IMAGES.ev },
  { id: 10, title: "AI CRM Rollout — Retail Chain", category: "Digital", image: IMAGES.digital },
  { id: 11, title: "25kW Industrial Solar — Rice Mill", category: "Solar", image: IMAGES.solar },
];

export default function Projects() {
  return (
    <div data-testid="projects-page">
      <section className="bg-white py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="label-eyebrow">Projects</div>
          <h1 className="mt-4 font-heading font-black text-5xl md:text-7xl tracking-tighter text-slate-950 max-w-4xl">
            500+ installations. <span className="italic font-light">Every district.</span>
          </h1>
          <p className="mt-6 max-w-2xl text-lg text-slate-600">A selection of recent work across solar, security, EV and digital infrastructure.</p>
        </div>
      </section>

      <section className="bg-slate-50 py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {ALL.map((p) => (
            <div key={p.id} className="card-flat overflow-hidden group" data-testid={`project-item-${p.id}`}>
              <div className="relative h-64 overflow-hidden">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute top-4 left-4 bg-white text-slate-950 text-[10px] uppercase tracking-wider font-bold px-2.5 py-1">{p.category}</div>
              </div>
              <div className="p-6">
                <h3 className="font-heading font-bold text-lg text-slate-950 leading-tight">{p.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8"><LeadForm source="projects" /></div>
      </section>
    </div>
  );
}
